export default __webpack_public_path__ + "static/media/7.22e4f236.png";